import { useMemo } from 'react';

import { Course } from '../../../db/courses/types';
import { Class } from '../../../db/classes/types';
import { getClassStatus, getClassTimingText, getClassWidgetVariant } from '../helpers';

export interface Props {
  course: Course | undefined;
  cls: Class | undefined;
}

const useClassCardVM = ({ course, cls }: Props) => {
  const classWidgetData = useMemo(() => {
    if (!(course && cls)) return null;
    return {
      date: cls.startTime,
      id: cls.id,
      timing: getClassTimingText(cls),
      variant: getClassWidgetVariant(cls),
    };
  }, [cls, course]);

  const { isClassInSession, isClassClosed } = getClassStatus(cls?.status);

  return {
    classWidgetData,
    isClassInSession,
    isClassClosed,
  };
};

export default useClassCardVM;
